/* eslint-disable import/prefer-default-export */
import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Button, Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { PRIMARY_FONT } from '../../../theme/fontConstants';

const PositionTemplatesSection = ({
  availablePositionTemplates,
  selectedPositionTemplates,
  onPositionTemplateToggle,
  onSelectAll,
  onClear,
  corporationSelected,
}) => {
  const theme = useTheme();

  const questionStyle = {
    color: theme?.palette?.text?.primary,
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[300],
    marginBottom: theme.spacing(1),
  };

  return (
    <>
      <Typography sx={questionStyle}>
        {LanguageConverterV2('contract.create.positionsQuestion')}
      </Typography>
      <Box sx={{ mb: 2 }}>
        <Button
          variant="contained"
          size="small"
          sx={{ mr: 1, mb: 1, textTransform: 'none' }}
          onClick={onSelectAll}
          disabled={!corporationSelected || availablePositionTemplates.length === 0}
        >
          {LanguageConverterV2('contract.create.selectAll')}
        </Button>
        <Button
          variant="outlined"
          size="small"
          sx={{ mb: 1, textTransform: 'none' }}
          onClick={onClear}
          disabled={selectedPositionTemplates.length === 0}
        >
          {LanguageConverterV2('contract.create.clear')}
        </Button>
      </Box>
      <Box
        sx={{
          border: '1px solid #e0e0e0',
          borderRadius: 1,
          p: 2,
          maxHeight: '200px',
          overflowY: 'auto',
          mb: 3,
        }}
      >
        {corporationSelected ? (
          <FormGroup>
            {availablePositionTemplates.map((template) => (
              <FormControlLabel
                key={template._id}
                control={
                  <Checkbox
                    checked={selectedPositionTemplates.some((pt) => pt._id === template._id)}
                    onChange={() => onPositionTemplateToggle(template)}
                  />
                }
                label={template.name}
              />
            ))}
            {availablePositionTemplates.length === 0 && (
              <Typography color="text.secondary">
                {LanguageConverterV2('contract.create.noPositionTemplates')}
              </Typography>
            )}
          </FormGroup>
        ) : (
          <Typography color="text.secondary">
            {LanguageConverterV2('contract.create.selectCorporationFirst')}
          </Typography>
        )}
      </Box>
    </>
  );
};

PositionTemplatesSection.propTypes = {
  availablePositionTemplates: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  selectedPositionTemplates: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  onPositionTemplateToggle: PropTypes.func.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  corporationSelected: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
  }),
};

export default PositionTemplatesSection;
